import { render, staticRenderFns } from "./AsignacionesHistorialTabContent.vue?vue&type=template&id=2af5f69c"
import script from "./AsignacionesHistorialTabContent.vue?vue&type=script&lang=js"
export * from "./AsignacionesHistorialTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports